<input type="date" /> <input type="datetime" /> <input type="week" />
<input type="month" /> <input type="time" /> <input type="number" />
<input type="range" /> <input type="tel" /> <input type="url" />
<input type="email" /> <input type="color" /> <input type="radio" />
<input type="checkbox" />
